import React from 'react'
import "./ServiceCenterLocatorPageContent.css"
const StoreLocatorContentCard = (serviceCenterLocatorData) => {

  const address = serviceCenterLocatorData?.data?.BaseAddressLine;
  const addressLines = address?.split(/\r\n/);

  return (
    <>
      <section className='service-center-locator-content-section-card'>
        <div className='container'>
          <div className="row">
            <div className="col-md-8 offset-md-2">
              {(serviceCenterLocatorData?.data) ?
                <div className="store-locator-card">
                  <h4 className='store-fs-large'>{serviceCenterLocatorData?.data?.CustomerName ? serviceCenterLocatorData?.data?.CustomerName : ""}{serviceCenterLocatorData?.data?.CustomerType ? `, ${serviceCenterLocatorData?.data?.CustomerType}` : ""}</h4>
                  <div className="row">
                    <div className="col-md-10">
                      <div className="para-store-add">
                        {serviceCenterLocatorData?.data?.contactPerson ? <p className='store-font'><strong> Contact Person:</strong> {serviceCenterLocatorData?.data?.contactPerson} </p> : ""}
                        {serviceCenterLocatorData?.data?.ContactNo && <span className='store-font'><strong>Mobile: </strong> {serviceCenterLocatorData?.data?.ContactNo}</span>} {serviceCenterLocatorData?.data?.email && <span className='store-font'><strong>Email: </strong> {serviceCenterLocatorData?.data?.email}</span>}
                        <p className='store-font'><strong>Address: </strong>{serviceCenterLocatorData?.data?.address}{serviceCenterLocatorData?.data?.city ? `, ${serviceCenterLocatorData?.data?.city}` : ""}{serviceCenterLocatorData?.data?.state ? `, ${serviceCenterLocatorData?.data?.state}` : ""}{serviceCenterLocatorData?.data?.country ? `, ${serviceCenterLocatorData?.data?.country}` : ""}{serviceCenterLocatorData?.data?.pincode ? `, ${serviceCenterLocatorData?.data?.pincode}` : ""}</p>
                      </div>
                    </div>
                    {serviceCenterLocatorData?.data?.ContactNo &&
                      <div className="col-md-2">
                        <div className="phone-icon store-font">
                          <a href={`tel:${serviceCenterLocatorData?.data?.ContactNo}`}><img src="/images/store-locator/phone.png" alt="" /></a>
                        </div>
                      </div>}
                  </div>
                </div>
                : <h4>No Stores Available At This Location.</h4>
              }
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default StoreLocatorContentCard